import { ChainId } from '@uniswap/smart-order-router'

export const AUTO_ROUTER_SUPPORTED_CHAINS: ChainId[] = Object.values(ChainId) as number[]
